import React from "react";
import { Card } from "reactstrap";
import { Icon } from "../../../Component";
import { TotalSalesChart } from "../../charts/e-commerce/EcomCharts";
import { RUPEES_SYMBOL } from "../../../../assets/constants";

const TotalSales = ({data,isLoading}) => {
  console.log("Total Sales Data:", data);
  return (
    <Card className="is-dark h-100">
      <div className="nk-ecwg nk-ecwg1">
        <div className="card-inner">
          <div className="card-title-group">
            <div className="card-title">
              <h6 className="title">Total Sales</h6>
            </div>
            <div className="card-tools">
              <a href="#report" onClick={(ev) => ev.preventDefault()} className="link">
                View Report
              </a>
            </div>
          </div>
           <div className="data">
            <div className="amount">
              {RUPEES_SYMBOL} {data?.overAllSales||0}
            </div>
            <div className="info">
              <strong>
                {RUPEES_SYMBOL} {data?.last_month_sales||0}
              </strong>{" "}
              in last month
            </div>
          </div>
          <div className="data">
            <h6 className="sub-title">This week so far</h6>
            <div className="data-group">
              <div className="amount">
                {RUPEES_SYMBOL} {data?.this_week_sales||0}
              </div>
              <div className="info text-end">
                <span className={`change ${data?.growth ? "up" : "down"} text-danger`}>
                  <Icon name={data?.growth ? "arrow-long-up" : "arrow-long-down"}></Icon>
                  {data?.percent_change||0}%
                </span>
                <br />
                <span>vs. last week</span>
              </div>
            </div>
          </div>
        </div>
        <div className="nk-ecwg1-ck">
         {isLoading?"": <TotalSalesChart data={data?.totalSales} isLoading={isLoading} />}
        </div>
      </div>
    </Card>
  );
};

export default TotalSales;
